import './TeasingPage.style'

import { PureComponent } from 'react'

import Html from 'Component/Html';
import ExpandableContent from 'Component/ExpandableContent';
import Link from 'Component/Link';
import Countdown from 'Component/Countdown';
import Newsletter from 'Component/Newsletter';
import CmsBlock from 'Component/CmsBlock';

import isMobile from 'Util/Mobile';
import {isSignedIn} from 'Util/Auth';

class TeasingPage extends PureComponent {

    renderTitle() {
        const { promotion: { title } } = this.props;

        return <h1 block="TeasingPage" elem="Title">{ title }</h1>
    }

    renderTimer() {
        const { isLoading, promotion: { is_active, start_date, end_date, today, counter_title_before, counter_title_after} } = this.props;
        const timerDate = is_active ? end_date : start_date;

        if (isLoading) {
            return (
                <div block="TeasingPage" elem="Timer" mods={{ Loading: true }}></div>
            );
        }
        return (
            <div block="TeasingPage" elem="Timer" mods={{ active: !!is_active }}>
                <span block="TeasingPage" elem="TimerTitle">{ is_active ? counter_title_after : counter_title_before }</span>
                <Countdown date={ timerDate } currentDate = { today } />
                <span block="TeasingPage" elem="TimerText"> { is_active ? <CmsBlock identifier="teasing_counter_block_active" /> : <CmsBlock identifier="teasing_counter_block_inactive" /> }</span>
            </div>
        )
    }

    renderBanner() {
        const { isLoading, promotion: { is_active, banner_image, banner_image_inactive, banner_link } } = this.props;

        if (isLoading) {
            return <div block="TeasingPage" elem="Banner" mods={{ Loading: true }}></div>;
        }

        // Use banner_link if available, otherwise default to 'www.farmec.ro'
        const link = banner_link || 'www.farmec.ro';

        return (
            <div block="TeasingPage" elem="Banner">
                {is_active
                    ? <Link to={link}><img src={banner_image} alt="Active Banner" /></Link>
                    : <img src={banner_image_inactive} alt="Inactive Banner" />
                }
            </div>
        );
    }


    renderText() {
        const {
            promotion: {
                active_block_title,
                active_button_link,
                active_button_title,
                active_button_link_logged_in,
                active_button_title_logged_in
            }
        } = this.props;
        const isLoggedIn = isSignedIn();

        // Use active_button_link if available, otherwise default to 'www.farmec.ro'
        const link = isLoggedIn ? (active_button_link_logged_in || 'www.farmec.ro') : (active_button_link || 'www.farmec.ro');
        const buttonTitle = isLoggedIn ? active_button_title_logged_in : active_button_title;

        return (
            <div block="TeasingPage" elem="Text">
                <div block="TeasingPage" elem="TextContent">
                    <h2>{active_block_title}</h2>
                    <CmsBlock identifier="teasing_inactive_promo_block" />
                    <Link to={link} block="Button">{buttonTitle}</Link>
                </div>
            </div>
        );
    }


    renderNewsletter() {
        const { promotion: { newsletter_title } } = this.props;

        return (
            <div block="TeasingPage" elem="Newsletter">
                <div block="TeasingPage" elem="NewsletterContent">
                    <h2>{ newsletter_title }</h2>
                    <CmsBlock identifier="teasing_newsletter_block" />
                    <Newsletter button_text={ __('Subscribe') } />
                </div>
            </div>
        )
    }

    renderNewsletterAndPromo() {
        const { promotion: { is_active } } = this.props;
        if (!is_active) {
            return this.renderText();
        } else {
            return this.renderNewsletter();
        }
    }

    renderCmsContent() {
        return (
            <div block="TeasingPage" elem="Cms">
                <CmsBlock identifier="teasing_cms_block" />
            </div>
        )
    }

    render() {
        return (
            <div block="TeasingPage">
                <div block="TeasingPage" elem="Container">
                    { this.renderTitle() }
                    { this.renderTimer() }
                    <div block="TeasingPage" elem="Cols">
                        { this.renderBanner() }
                        { !isMobile.any() && this.renderNewsletterAndPromo() }
                    </div>
                </div>
                { isMobile.any() && this.renderNewsletterAndPromo() }
                { this.renderCmsContent() }
            </div>
        )
    }

}

export default TeasingPage
